import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface FieldProps {
  name: string;
  label: string;
  hint?: React.ReactNode;
  error?: string;
  className?: string;
  children: React.ReactNode;
}
export function errorId(name: string): string {
  return `${name}-error`;
}
export function hintId(name: string): string {
  return `${name}-hint`;
}

/** Spread onto the control so hint and error are announced. */
export function describedBy(name: string, hint?: React.ReactNode, error?: string) {
  const ids = [hint ? hintId(name) : null, error ? errorId(name) : null].filter(Boolean);
  return {
    'aria-invalid': error ? true : undefined,
    'aria-describedby': ids.length ? ids.join(' ') : undefined
  };
}
export function Field({
  name,
  label,
  hint,
  error,
  className = '',
  children
}: FieldProps) {
  return <div className={`flex flex-col gap-1.5 ${className}`} data-id="element-526" data-mp="rt0lxktg9f9s">
      <label htmlFor={name} className="text-small font-medium text-ink" data-id="element-527" data-mp="wr26ybafronw">
        {label}
      </label>
      {hint ? <span id={hintId(name)} className="text-small text-ink-muted" data-id="element-528" data-mp="ybz629bv0hjm">
          {hint}
        </span> : null}
      {children}
      {error ? <span id={errorId(name)} role="alert" className="flex items-start gap-1.5 text-small font-medium text-accent" data-id="element-529" data-mp="tefrf8b922r5">
          <AlertCircleIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" data-id="element-530" data-mp="kcq0s4p6z7uf" />
          {error}
        </span> : null}
    </div>;
}